import { render, staticRenderFns } from "./UploadOrgPictures.vue?vue&type=template&id=33b0064f&scoped=true"
import script from "./UploadOrgPictures.vue?vue&type=script&lang=js"
export * from "./UploadOrgPictures.vue?vue&type=script&lang=js"
import style0 from "./UploadOrgPictures.vue?vue&type=style&index=0&id=33b0064f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b0064f",
  null
  
)

export default component.exports